import AppointmentDetailTabs from './AppointmentDetailTabs.container';
export default AppointmentDetailTabs;
